module.exports = __webpack_public_path__ + "f451c4dfbda1aa1692691110eb7dc08a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/imageslider/slider-02.jpg
 ** module id = 24
 ** module chunks = 0
 **/